import { Client } from '../Client';

const controllerName = 'Users';

const checkIfUserHasAccess = async (): Promise<boolean> => {
  return Client('GET', controllerName);
};

export { checkIfUserHasAccess };
